import * as React from 'react';
import _ from 'lodash';
import { useUserContext } from 'common/contexts/UserContext';
import { Profile } from 'types/User';
import { Member } from './Member';

interface Props {
  selected: (string | null)[];
  setSelected: (selected: (string | null)[]) => void;
  search?: string;
}

type SimplifiedMember = {
  label: string;
  value: string | null;
  profile: Profile | null;
};

export const Members: React.FC<Props> = (props) => {
  const { selected, setSelected, search } = props;
  const { user } = useUserContext();

  const handleSelect = React.useCallback(
    (profile: Profile | null, checked: boolean) => {
      const email = profile?.email || null;
      if (checked) {
        setSelected([...new Set([...selected, email])]);
      } else {
        setSelected(selected.filter((e) => e !== email));
      }
    },
    [setSelected, selected]
  );

  const members = React.useMemo(() => {
    if (!user) {
      return [];
    }

    let simplified: SimplifiedMember[] = user.teamMembers.map((member) => ({
      label: `${member.first_name} ${member.last_name} (${member.email})`,
      value: member.email,
      profile: member,
    }));

    if (search) {
      simplified = simplified.filter((member) =>
        member.label.toLowerCase().includes(search.toLowerCase())
      );
    }

    simplified = _.sortBy(simplified, ['label']);
    simplified = _.concat([{ label: 'Deleted user', value: null, profile: null }], simplified);
    return simplified;
  }, [user, search]);

  if (!user) {
    return null;
  }

  const rows = members.map((member) => {
    const checked = selected.includes(member.value);
    return (
      <Member
        key={member.value}
        profile={member.profile}
        onChange={handleSelect}
        checked={checked}
      />
    );
  });

  return <div className="max-h-96 overflow-y-auto">{rows}</div>;
};
Members.displayName = 'Shipments.DeletedContainers.ActionBar.DeletedBy.Members';
